module.exports = __webpack_public_path__ + "img/iphone2.fdd49e16.png";